import React from 'react'
import './Mission.scss'
const Mission = () => {
  return (
    <section className='section mission-section'>
      <div className='section-center mission-center'>
        <h1>mission is to protect your businesses & much more</h1>
        <button className='btn mission-btn'>discover more</button>
      </div>
    </section>
  )
}

export default Mission
